import React from "react";
import Topbar from "./topbar";
import Navbar from "./navbar";
import Footer from "./footer";
import "../App.css";

function PrivacyPolicy() {
  const sections = [
    ["information", "Information We Collect"],
    ["usage", "How We Use Your Information"],
    ["legal-bases", "Legal Bases for Processing"],
    ["cookies", "Cookies & Tracking"],
    ["sharing", "How We Share Your Information"],
    ["retention", "Data Retention"],
    ["security", "Data Security"],
    ["rights", "Your Privacy Rights"],
    ["transfers", "International Data Transfers"],
    ["children", "Children's Privacy"],
    ["third-party", "Third-Party Links"],
    ["changes", "Changes to This Policy"],
    ["contact", "Contact Us"],
  ];

  return (
    <div className="privacy-page">
      <div className="privacy-grid">
        {/* SIDEBAR */}
        <aside className="privacy-nav">
          <div className="privacy-nav-card">
            <div className="privacy-nav-title">
              Contents
            </div>
            <nav>
              {sections.map(([id, title], index) => (
                <a href={`#${id}`} key={id}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  {title}
                </a>
              ))}
            </nav>
          </div>
        </aside>
        {/* POLICY */}
        <main className="privacy-document">
          <div className="privacy-header-inner">
            <div className="privacy-header-icon">
              <i className="bi bi-shield-check"></i>
            </div>
            <div>
              <h2>Privacy Policy</h2>
              <div className="policy-meta">
                <span>
                  <i className="bi bi-calendar3"></i>
                  Last updated
                </span>
                <strong>July 25, 2026</strong>
              </div>
            </div>
          </div>
          {/* Intro */}
          <div className="privacy-document-intro">
            <p>
              This Privacy Policy explains how{" "}
              <strong>Neeyum Solutions LLP</strong> ("we," "us," or "our")
              collects, uses, discloses, and safeguards your information when
              you visit our website and use our services (collectively, the
              "Service").
            </p>

            <p>
              By using the Service,you agree to the collection and use of
              information in accordance with this policy.
            </p>
          </div>

          {/* 01 */}
          <section id="information" className="policy-section">
            <div className="policy-heading">
              <span>01</span>
              <h2>Information We Collect</h2>
            </div>

            <h3>Information you provide to us</h3>

            <ul>
              <li>
                <strong>Account information:</strong> Name, email address,
                username, password, and profile details when you register.
              </li>

              <li>
                <strong>Content:</strong> Information you submit, post, or
                upload through the Service.
              </li>

              <li>
                <strong>Communications:</strong> Messages you send us for
                support or feedback.
              </li>

              <li>
                <strong>Payment information:</strong> Billing details processed
                through our payment providers(We do not store full card
                numbers).
              </li>
            </ul>

            <h3>Information collected automatically</h3>

            <ul>
              <li>
                <strong>Usage data:</strong> Pages visited, features used, time
                spent, referring/exit pages, and interaction data.
              </li>

              <li>
                <strong>Device and connection data:</strong> IP address, browser
                type, operating system, device identifiers, and language
                settings.
              </li>

              <li>
                <strong>Cookies and similar technologies:</strong> See the
                Cookies section below.
              </li>
            </ul>

            <h3>Information from third parties</h3>

            <ul>
              <li>
                <strong>Authentication providers:</strong> If you sign in via
                Google, Facebook, or another provider ,we receive basic profile
                information that you authorize.
              </li>

              <li>
                <strong>Analytics and advertising partners :</strong>
                aggregated or pseudonymized data about your activity.
              </li>
            </ul>
          </section>

          {/* 02 */}
          <section id="usage" className="policy-section">
            <div className="policy-heading">
              <span>02</span>
              <h2>How We Use Your Information</h2>
            </div>
            <ul>
              <li>To provide, operate, maintain, and improve the Service.</li>

              <li>To create and manage your account and authenticate you.</li>

              <li>To process transactions and related information.</li>

              <li>
                To respond to support requests, comments, and support inquiries.
              </li>

              <li>
                To send administrative messages, updates and(with consent where
                required)marketing communications.
              </li>

              <li>To personalize content and recommendations</li>

              <li>
                To monitor usage, detect nd prevent fraud, and ensure security.
              </li>

              <li>
                To comply with legal obligations laws and enforce our terms.
              </li>
            </ul>
          </section>

          {/* 03*/}
          <section id="legal-bases" className="policy-section">
            <div className="policy-heading">
              <span>03</span>
              <h2>Legal Bases for Processing(EEA/UK Users)</h2>
            </div>

            <p>
              If you are located in the European Economic Area or United
              Kingdom, we process your personal data under the following legal
              bases:
            </p>

            <ul>
              <li>
                <strong>Consent:</strong> Where you have given us
                permission(e.g.,marketing, non-essential cookies).
              </li>

              <li>
                <strong>Contract:</strong> Where processing is necessary to
                provide the Service you requested.
              </li>

              <li>
                <strong>Legal obligation:</strong> Where we musst comply with
                the law.
              </li>

              <li>
                <strong>Legitimate interests:</strong> For security, fraud
                prevention, and improving our Service, provided these do not
                override your rights.
              </li>
            </ul>
          </section>

          {/* 04 */}
          <section id="cookies" className="policy-section">
            <div className="policy-heading">
              <span>04</span>
              <h2>Cookies and Tracking Technologies</h2>
            </div>

            <p>
              We use cookies and similar technologies to operate the Service,
              remember your preferences, analyze usage, and (where applicable)
              deliver relevant advertising.
            </p>

            <div className="policy-table-wrapper">
              <table className="policy-table">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Purpose</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>Essential</td>
                    <td>
                      Required for core functionality such as login,and
                      security. Can not be disabled.
                    </td>
                  </tr>

                  <tr>
                    <td>Preferences</td>
                    <td>Remember your settings and choices.</td>
                  </tr>

                  <tr>
                    <td>Analytics</td>
                    <td>
                      Help us understand how the Service is used(e.g.,[Google
                      Analytics]).
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p>
              you can manage cookies through your browser settings and,where
              offered,our cokkie conssent banner. Disabling some cookies may
              affect some functionality.
            </p>
          </section>

          {/*05 */}
          <section id="sharing" className="policy-section">
            <div className="policy-heading">
              <span>05</span>
              <h2>How We Share Your Information</h2>
            </div>

            <p>
              We do not sell your personal information for money. We may share
              information with:
            </p>

            <ul>
              <li>
                <strong>Service providers:</strong> who perform services on our
                behalf(hosting, analytics, payment processing, customer
                support), bound by confidentially obligations.
              </li>

              <li>
                <strong>Advertising and analytics partners:</strong> in
                accordance with their own privacy policies.
              </li>

              <li>
                <strong>Business transfers:</strong> In connection with a
                merger, acquisition, or sale of assets.
              </li>

              <li>
                <strong>Legal reasons:</strong> to comply with law, respond to
                lawful requests, or protect the rights, property, and safety of
                our users and others.
              </li>

              <li>
                <strong>With your consent:</strong> For any other purpose
                disclosed at the time.
              </li>
            </ul>
          </section>

          {/* 06 */}
          <section id="retention" className="policy-section">
            <div className="policy-heading">
              <span>06</span>
              <h2>Data Retention</h2>
            </div>

            <p>
              We retain personal information for as long as necessary to provide
              the Service, comply with legal obligations, resolve disputes, and
              enforce our agreements. When no longer needed, we delete or
              anonymize it.
            </p>
          </section>

          {/* 07 */}
          <section id="security" className="policy-section">
            <div className="policy-heading">
              <span>07</span>
              <h2>Data Security</h2>
            </div>

            <p>
              We implement reasonable administrative, technical, and physical
              safeguards designed to protect your information. However, no
              method of transmission or storage is completely secure, and we
              cannot guarantee absolute security.
            </p>
          </section>

          {/* 08 */}
          <section id="rights" className="policy-section">
            <div className="policy-heading">
              <span>08</span>
              <h2>Your Privacy Rights</h2>
            </div>

            <h3>EEA / UK (GDPR)</h3>

            <p>
              You may have the right to access, correct, delete, restrict, or
              object to processing of your personal data, to data portability,
              and to withdraw consent. You may also lodge a complaint with your
              local data protection authority.
            </p>

            <h3>California(CCPA/CPRA)</h3>

            <p>
              California residents may have the right to know what personal
              information we collect, to request deletion or correction, to opt
              out of the "sale" or "sharing" of personal information, and to not
              be discriminated against for exercising these rights.
            </p>

            <div className="privacy-request">
              <div>
                <p>To exercise any of these rights, contact us at :</p>

                <a href="mailto:privacy@neeyumsolutions.in">
                  privacy@neeyumsolutions.in
                </a>
                <p>
                  {" "}
                  We will respond within the timeframe required by applicable
                  law.
                </p>
              </div>
            </div>
          </section>

          {/* 09 */}
          <section id="transfers" className="policy-section">
            <div className="policy-heading">
              <span>09</span>
              <h2>International Data Transfers</h2>
            </div>

            <p>
              Your information may be transferred to and processed in countries
              other than your country of residence. Where required, we use
              appropriate safeguards such as Standard Contractual Clauses to
              protect your data.
            </p>
          </section>

          {/* 10 */}
          <section id="children" className="policy-section">
            <div className="policy-heading">
              <span>10</span>
              <h2>Children's Privacy</h2>
            </div>

            <p>
              The Service is not directed to children under{" "}
              <strong>[13/16]</strong>,we do not knowingly collect personal
              information from them. If you believe a child has provided us
              information, contact us and we will delete it.
            </p>
          </section>

          {/* 11 */}
          <section id="third-party" className="policy-section">
            <div className="policy-heading">
              <span>11</span>
              <h2>Third-Party Links</h2>
            </div>

            <p>
              The Service may contain links to third-party sites we do not
              control. We are not responsible for their privacy practices, and
              we encourage you to review their policies.
            </p>
          </section>

          {/* 12 */}
          <section id="changes" className="policy-section">
            <div className="policy-heading">
              <span>12</span>
              <h2>Changes to This Policy</h2>
            </div>

            <p>
              We may update this Privacy Policy from time to time. We will post
              the revised version with a new "Last updated" date and, where
              appropriate, notify you.
            </p>
          </section>

          {/* 13 */}
          <section id="contact" className="policy-section">
            <div className="policy-heading">
              <span>13</span>
              <h2>Contact Us</h2>
            </div>

            <p>
              If you have any questions or concerns regarding this Privacy
              Policy, please contact us:
            </p>

            <div className="privacy-contact">
              <div className="contact-icon">
                <i className="bi bi-building"></i>
              </div>

              <div>
                <h3>Neeyum Solutions LLP</h3>

                <p>
                  <strong>Email:</strong>{" "}
                  <a href="mailto:privacy@neeyumsolutions.in">
                    privacy@neeyumsolutions.in
                  </a>
                </p>

                <p>
                  <strong>Address:</strong>
                  <br />
                  15/16/17, Sheetal Darshan CHS,
                  <br />
                  Sheetal Nagar, MTNL Road,
                  <br />
                  Opp. Shahi Hotel,
                  <br />
                  Mira Road, Bhayandar - 401107.
                </p>
              </div>
            </div>
          </section>

          {/* Bottom */}
          <div className="privacy-bottom">
            <div>
              <i className="bi bi-shield-check"></i>
              Your privacy is important to us.
            </div>

            <a href="/">← Back to Home</a>
          </div>
        </main>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
